import { Button } from "@/design-system/Button/Button";
import { useTranslation } from "@repo/shared/i18n";
import { Plus } from "lucide-react";

/**
 * Opens the player search, with how many cards are in already: "Add players +"
 * on desktop, a bare "+" beside the progress bar on mobile.
 */
export const AddPlayerButton = ({
  onClick,
  count = 0,
  disabled = false,
  compact = false,
}: {
  onClick: () => void;
  /** The added cards: shown as a badge before the label when there are any. */
  count?: number;
  disabled?: boolean;
  /** Mobile: the plus alone, beside the progress bar. */
  compact?: boolean;
}) => {
  const { t } = useTranslation("sbcs");
  const badge = count > 0 && (
    <span className="flex h-5 min-w-5 items-center justify-center rounded-full bg-streamline-success px-1.5 text-xs font-bold tabular-nums text-streamline-on-success">
      {count}
    </span>
  );
  return (
    <Button
      variant="tertiary"
      size="small"
      icon={<Plus />}
      iconPosition="right"
      onClick={onClick}
      disabled={disabled}
      className="shrink-0"
      aria-label={compact ? t("streamline.addPlayers") : undefined}
    >
      {compact ? (
        // No children renders the round icon-only button.
        badge || undefined
      ) : (
        /* One child, so the row's direction, reversed when the plus trails,
           keeps the label ahead of the badge. */
        <span className="flex items-center gap-2.5">
          <span>{t("streamline.addPlayers")}</span>
          {badge}
        </span>
      )}
    </Button>
  );
};
